// extracted by mini-css-extract-plugin
export default {"section":"NucleappProduct_section__N5wW1","textBlue":"NucleappProduct_textBlue__F4wWh","appContainer":"NucleappProduct_appContainer__QX6Fq"};